import '../modules/select';
import '../modules/counter';
import '../modules/inputmask';
import '../modules/input-empty';

// Show info for delivery
$('.js-checked-add-info').on('click', function () {
  const id = $(this).attr('id');
  const parent = $(this).closest('.form-checkout__grid');
  const drop = parent.find('.form-checkout__drop');

  if (id === 'delivery_address') {
    parent.addClass('form-checkout__grid--add-height');
    drop.slideDown();

  } else {
    parent.removeClass('form-checkout__grid--add-height');
    drop.slideUp();
  }
});